// extracted by mini-css-extract-plugin
export default {"outerContainer":"CardWithStatus_outerContainer__viBE3","innerContainer":"CardWithStatus_innerContainer__Z7rKp"};